import { render, staticRenderFns } from "./BaseIconButton.vue?vue&type=template&id=8d09fc82&scoped=true"
import script from "./BaseIconButton.vue?vue&type=script&lang=js"
export * from "./BaseIconButton.vue?vue&type=script&lang=js"
import style0 from "./BaseIconButton.vue?vue&type=style&index=0&id=8d09fc82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d09fc82",
  null
  
)

export default component.exports